import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import {
  EjecutarFirmaRequest,
  EjecutarFirmaResponse,
} from '../../models/ejecutar-firma/ejecutar-firma';

@Injectable({
  providedIn: 'root',
})
export class EjecutarFirmaElectronicaService {
  private readonly baseUrl = environment.HOST;

  constructor(private http: HttpClient) {}

  ejecutarFirmaElectronica(
    request: EjecutarFirmaRequest,
  ): Observable<EjecutarFirmaResponse> {
    return this.http.post<EjecutarFirmaResponse>(
      `${this.baseUrl}${URL_MAP.API.FIRMA_ELECTRONICA_EJECUTAR}`,
      request,
    );
  }
}
